export default "/images/vendor/flag-icons/flags/1x1/vi.svg?f5fa039cd7dda2cd11ce61b864f308ff";